export enum CalendarViewType {
  resourceTimelineDay = 'resourceTimelineDay',
  resourceTimelineWeek = 'resourceTimelineWeek',
  resourceTimelineMonth = 'resourceTimelineMonth',
  resourceTimelineWeeksSlot = 'resourceTimelineWeeksSlot',
  customThreeYearTimeline = 'customThreeYearTimeline',
  resourceTimelineThreeMonths = 'resourceTimelineThreeMonths',
  resourceTimelineThreeWeeks = 'resourceTimelineThreeWeeks'
}
